import React from "react";
import { VscAccount } from 'react-icons/vsc';

const greet = () => {
    const firstname = sessionStorage.getItem("firstName");
    const lastname = sessionStorage.getItem("lastName");
    const Id = sessionStorage.getItem("Id");
    console.log("firstname",firstname);
    console.log("lastname",lastname);
    console.log("Id",Id);
    return (
        
        <div className="greet">
           <small>Welcome, {firstname} {lastname}!!</small>
        </div>
        
    )
}

export default greet;